import {collection, doc, onSnapshot, updateDoc} from 'firebase/firestore'
import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import db from '../../../../services/firebase'
import {useAuth} from '../../../modules/auth'
import { showSuccessToast } from 'app/components/ShowToast'

interface ViewProps {
  isOpen: boolean
  onClose: () => void
  ids: string[]
}

const AssignOwner: React.FC<ViewProps> = ({isOpen, onClose, ids}) => {
  const [owner, setOwner] = useState('')
  const [owners, setOwners] = useState<any[]>([])
  const {currentUser} = useAuth()

  useEffect(() => {
    const tenantId = currentUser?.tenantId || ''
    const tenantRef = doc(db, 'tenants', tenantId)
    const PolicyRef = collection(tenantRef, 'employees')

    const unsubscribe = onSnapshot(PolicyRef, (snapshot) => {
      const risksData = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
        end_date:doc.data().end_date
      })).filter((data)=>!data.end_date)
    
      setOwners(risksData)
    })

    return unsubscribe
  }, [])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    try {
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)

      const updatePromises = ids.map((policyId) => {
        const policyDocRef = doc(tenantRef, 'policies', policyId)
        return updateDoc(policyDocRef, {owner})
      })

      await Promise.all(updatePromises)
      showSuccessToast({message: `Assigned owner to ${ids.length} policy successfully`})
      onClose()
    } catch (error) {
      console.error('Error assigning owner:', error)
    }
  }

  return (
    <Modal show={isOpen} onHide={onClose} backdropClassName='bg-opacity-1' centered>
      <Modal.Header closeButton>
        <Modal.Title>Assign Owner to {ids.length} Policies</Modal.Title>
      </Modal.Header>
      <Modal.Body className='p-0 mt-4'>
        <form className='px-6' onSubmit={handleSubmit}>
          <div className='fs-6 mb-4 fw-semibold'>
            Policy owner will be responsible for reviewing & approving documents.{' '}
            <strong>Warning:</strong> This action will assign new owner for all selected policies &
            override any existing owners.
          </div>

          <div className='fv-row  '>
            <label className=' fw-semibold fs-6 mb-1'>Assign to</label>
            <select
              data-placeholder='Select Owner'
              onChange={(e) => setOwner(e.target.value)}
              value={owner}
              className='form-select  mb-3 mb-lg-0 w-100'
            >
              <option value='' selected>
                Select Owner
              </option>
              {owners
                .filter((user) => user.role === 'Admin' || user.role === "Owner")
                .map((owner) => (
                  <option key={owner.id} value={owner.full_name}>
                    {owner.full_name}
                  </option>
                ))}
            </select>
          </div>

          <div className='modal-footer  p-0 my-4 pt-4'>
            <button
              className='btn btn-sm btn-light mx-4'
              onClick={onClose}
              // disabled={activities.length === 0}
              style={{
                width: '80px',
                height: '40px',
                borderRadius: '4px',
                transition: 'background-color 0.3s',
              }}
            >
              Cancel
            </button>

            <button
              className='btn btn-sm'
              type='submit'
              onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                (e.currentTarget.style.backgroundColor = '#148363')
              }
              onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                (e.currentTarget.style.backgroundColor = '#0E9F6E')
              }
              // disabled={activities.length === 0}
              style={{
                backgroundColor: '#0E9F6E',
                color: '#fff',
                height: '40px',
                borderRadius: '4px',

                transition: 'background-color 0.3s',
              }}
            >
              Assign
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  )
}

export default AssignOwner
